// @react/hooks/useSecretPki.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { secretPkiStore } from '@core/stores';

/**
 * React hook for  operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useSecretPki } from '@react/hooks';
 *
 * const List = observer(() => {
 *   const store = useSecretPki();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useSecretPki() {
  return secretPkiStore;
}
